import React from 'react';
import { CurrencyCircleDollar, CheckCircle, Warning, ArrowUp } from '@phosphor-icons/react';
import './TermlyFeeSummary.css';

function formatCurrency(amount) {
  return `GHS ${amount.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function TermlyFeeSummary({ summary, term }) {
  const paymentRate = summary.total_due > 0 
    ? Math.round((summary.total_paid / summary.total_due) * 100) 
    : 100;

  return (
    <div className="termly-fee-summary">
      <div className="summary-header">
        <div className="header-title">
          <h2>Termly Fee Summary</h2>
          {term && <span className="term-badge">{term}</span>}
        </div>
      </div>

      <div className={`fee-summary-card ${summary.balance > 0 ? 'outstanding' : 'fully-paid'}`}>
        {/* Primary Balance Section */}
        <div className="balance-section">
          <div className="balance-header">
            <div className="balance-status">
              {summary.balance > 0 ? (
                <div className="status-icon warning">
                  <Warning size={32} weight="fill" />
                </div>
              ) : (
                <div className="status-icon success">
                  <CheckCircle size={32} weight="fill" />
                </div>
              )}
              <div className="status-text">
                <span className="status-label">Outstanding Balance</span>
                <span className={`status-message ${summary.balance > 0 ? 'warning-text' : 'success-text'}`}>
                  {summary.balance > 0 ? 'Payment Required' : <>Fully Paid <CheckCircle size={14} weight="fill" /></>}
                </span>
              </div>
            </div>
            <div className="balance-amount">
              {formatCurrency(summary.balance)}
            </div>
          </div>

          {/* Progress Bar */}
          {summary.total_due > 0 && (
            <div className="payment-progress">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ width: `${paymentRate}%` }}
                ></div>
              </div>
              <span className="progress-label">{paymentRate}% Paid</span>
            </div>
          )}
        </div>

        {/* Stats Grid */}
        <div className="fee-stats-grid">
          <div className="stat-item">
            <div className="stat-header">
              <span className="stat-label">Total Due</span>
              <CurrencyCircleDollar size={18} className="stat-icon-small" />
            </div>
            <span className="stat-value">{formatCurrency(summary.total_due)}</span>
          </div>

          <div className="stat-item">
            <div className="stat-header">
              <span className="stat-label">Total Paid</span>
              <CheckCircle size={18} className="stat-icon-small success" />
            </div>
            <span className="stat-value success">{formatCurrency(summary.total_paid)}</span>
          </div>

          {summary.total_discount > 0 && (
            <div className="stat-item">
              <div className="stat-header">
                <span className="stat-label">Discount Applied</span>
                <span className="stat-icon-small discount">♦</span>
              </div>
              <span className="stat-value discount">{formatCurrency(summary.total_discount)}</span>
            </div>
          )}

          <div className="stat-item">
            <div className="stat-header">
              <span className="stat-label">Outstanding</span>
              <ArrowUp size={18} className="stat-icon-small" />
            </div>
            <span className={`stat-value ${summary.balance > 0 ? 'danger' : 'success'}`}>
              {formatCurrency(summary.balance)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermlyFeeSummary;
